import React, { useEffect, useState } from 'react';
import {
    Button,
    ButtonGroup,
    Card,
    Container,
    Form,
    Image,
    Modal,
    Stack,
    Table,
    Alert,
    Dropdown,
} from 'react-bootstrap';
import edit from '../../Assets/Img/edit.png';
import view from '../../Assets/Img/eye.png';
import NoDraft from '../../Assets/Img/noDrafts.png';
import {
    usePatientDraftListMutation,
    usePatientListMutation,
    usePatientDraftDeleteMutation,
    usePatientDraftApproveMutation,
    usePatientExcelFileMutation,
    usePatientExportMutation,
    usePatientDraftImportMutation,
} from './patientApi';
import { useSelector } from 'react-redux';
import AddPatient from './addPatient';
import AddDraftPatient from './AddDraftPatient';
import { useNavigate } from 'react-router';
import LoadingComponent from '../LoadingComponent';
import {
    Eye,
    Pencil,
    Plus,
    Upload,
    CheckCircle,
    Trash2,
    Download,
    FileText,
    File,
    Loader2,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import DeleteUser from '../Profile/deleteUser';
import './patientList.css';
import { setSecureItem,getSecureItem,removeSecureItem } from "../../utils/secureStorage";
import { getSecureSessionItem } from "../../utils/secureSessionStorage";
const PatientList = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const user = getSecureItem('UserData');
    const [editData, setEditData] = useState({});
    const [show, setShow] = useState(false);
    const [showDraftModal, setShowDraftModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [error, setError] = useState(null);
    const [exportLoading, setExportLoading] = useState(false);
    const patientData = useSelector((state) => state.patient);
    const [draftData, setDraftData] = useState([]);
    const [loading, setLoading] = useState(true);
    const config = {
        email: '',
        mobile: '',
        name: '',
        search: '',
        latestRecords: 0,
        pageSize: 50,
        pageNumber: 1,
        startDate: '',
        endDate: '',
    };
    const [tab, setTab] = useState('patient');
    const [pageCount, setPageCount] = useState(() => {
       let pageCountValue = getSecureSessionItem("pageCount");

        return pageCountValue ? pageCountValue.patient : 1;
    });
   // const [patientListConfig, setPatientListConfig] = useState(config);
   const [patientListConfig, setPatientListConfig] = useState(() => 
        {
            const saved = getSecureItem("patientListConfigCopy") || config;
            return saved ? saved : config;
        });

    const [patientList] = usePatientListMutation();
    const [patientDraftList] = usePatientDraftListMutation();
    const [patientDraftDelete] = usePatientDraftDeleteMutation();
    const [patientDraftApprove] = usePatientDraftApproveMutation();
    const [patientExcelFile] = usePatientExcelFileMutation();
    const [patientExport] = usePatientExportMutation();
    const [patientDraftImport] = usePatientDraftImportMutation();
    const [importLoading, setImportLoading] = useState(false);
    useEffect(() => {
        if (loading) {
            setError(null);
            if (tab === 'patient') {
                patientList(patientListConfig)
                    .then((data) => {
                        if (data.error) {
                            setError(
                                data.error.message || t('failedToLoadPatients')
                            );
                        }
                        setLoading(false);
                    })
                    .catch((err) => {
                        setError(t('failedToLoadPatients'));
                        setLoading(false);
                    });
            } else {
                patientDraftList(patientListConfig)
                    .then((data) => {
                        if (data.error) {
                            setError(
                                data.error.message || t('failedToLoadDrafts')
                            );
                        } else if (data.data) {
                            setDraftData(data.data.userProfileData || []);
                        }
                        setLoading(false);
                    })
                    .catch((err) => {
                        setError(t('failedToLoadDrafts'));
                        setLoading(false);
                    });
            }
        }
    }, [loading, tab]);

    const handleFilterChange = (count = 1) => {
        setSecureItem("patientListConfigCopy",patientListConfig);
        setPageCount(count);
        setPatientListConfig({ ...patientListConfig, pageNumber: count });
        setLoading(true);
    };

    const handleChange = (e) => {
        setPatientListConfig((prevValues) => {
            return {
                ...prevValues,
                [e.target.name]: e.target.value,
            };
        });
    };

    const handleFileUpload = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const handleImportSubmit = () => {
        if (!selectedFile) return;

        setImportLoading(true); // Start loading
        const formData = new FormData();
        formData.append('fileExcel', selectedFile);

        // Use the correct mutation based on the tab
        const importMutation =
            tab === 'draft' ? patientDraftImport : patientExcelFile;

        importMutation(formData)
            .then((response) => {
                if (response.error.data == 'success') {
                    setShowImportModal(false);
                    setSelectedFile(null);
                    setLoading(true);
                    setError(null);
                } else if (response.error) {
                    setError(
                        response.error.message ||
                            (tab === 'draft'
                                ? t('failedToImportDraftExcel')
                                : t('failedToImportExcel'))
                    );
                }
            })
            .catch((err) => {
                setError(
                    tab === 'draft'
                        ? t('failedToImportDraftExcel')
                        : t('failedToImportExcel')
                );
                console.error('Import error:', err);
            })
            .finally(() => {
                setImportLoading(false); // Stop loading regardless of success/failure
            });
    };

    const handleDeleteDraft = (userId) => {
        patientDraftDelete({ userId })
            .then((response) => {
                if (response.data) {
                    setLoading(true);
                } else if (response.error) {
                    setError(
                        response.error.message || t('failedToDeleteDraft')
                    );
                }
            })
            .catch((err) => {
                setError(t('failedToDeleteDraft'));
            });
    };

    const handleApprovePatient = (patient) => {
        const approveData = [
            {
                userId: '',
                email: patient.email,
                password: 'TempPassword123!',
                mobile: patient.phoneNumber,
                userType: 'PATIENT',
                languageId: 1,
                name: patient.firstName || '',
                lastName: patient.lastName || '',
                dateOfBirth: patient.dateOfBirth,
                doYouWearGlasses: patient.doYouWearGlasses || false,
                patientNameOfYourUsualEyeDoctor:
                    patient.patientNameOfYourUsualEyeDoctor || '',
                phoneNumber: patient.phoneNumber,
                typeOfVision: patient.typeOfVision || '',
                additionalComments: patient.additionalComments || '',
                gender: patient.gender || '',
                address: patient.address || '',
                isExternal: false,
                infoIsExternalDoctor: false,
                infoPrescriptionToOptician: false,
                isDoctorAvailable: false,
                imageRetino: false,
                isPio: false,
                isContactLense: false,
            },
        ];

        patientDraftApprove(approveData)
            .then((response) => {
                if (response.error.data == 'success') {
                    setLoading(true);
                } else if (response.error) {
                    setError(
                        response.error.message || t('failedToApprovePatient')
                    );
                }
            })
            .catch((err) => {
                setError(t('failedToApprovePatient'));
            });
    };

    const handleExport = (format = 'excel') => {
        setExportLoading(true);

        const exportData = {
            ...patientListConfig,
            exportFormat: format,
        };

        patientExport(exportData)
            .then((response) => {
                if (response.data) {
                    // For Excel/CSV exports, the response should be a blob
                    const blob = new Blob([response.data], {
                        type:
                            format === 'excel'
                                ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                : format === 'csv'
                                  ? 'text/csv'
                                  : 'application/pdf',
                    });

                    // Create download link
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;

                    let filename = 'patients';
                    if (format === 'excel') {
                        filename += '.xlsx';
                    } else if (format === 'csv') {
                        filename += '.csv';
                    } else if (format === 'pdf') {
                        filename += '.pdf';
                    }

                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();

                    // Clean up
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(link);
                } else if (response.error) {
                    setError(response.error.message || t('failedToExport'));
                }
            })
            .catch((err) => {
                setError(t('failedToExport'));
                console.error('Export error:', err);
            })
            .finally(() => {
                setExportLoading(false);
            });
    };

    if (loading) {
        return <LoadingComponent />;
    }

    const isEmpty =
        tab === 'patient'
            ? !patientData?.listData?.userProfileData ||
              patientData?.listData?.userProfileData.length === 0
            : !draftData || draftData.length === 0;

    return (
        <>
            <Container fluid className="list_wrapper">
                <Stack direction="horizontal" gap={3} className="mb-3">
                    <div className="">
                        <Button
                            variant={`${tab === 'patient' ? 'primary' : 'light'}`}
                            onClick={() => {
                                setTab('patient');
                                setPatientListConfig(config);
                                setLoading(true);
                            }}
                        >
                            {t('patients')}
                        </Button>{' '}
                        <Button
                            variant={`${tab === 'draft' ? 'primary' : 'light'}`}
                            onClick={() => {
                                setTab('draft');
                                setPatientListConfig(config);
                                setLoading(true);
                            }}
                        >
                            {t('drafts')}
                        </Button>
                    </div>

                    <Stack direction="horizontal" gap={2} className="ms-auto">
                        {tab === 'patient' && (
                            <>
                                {user?.userType == 'ADMIN' ? (
                                    <Dropdown>
                                        <Dropdown.Toggle
                                            variant="outline-primary"
                                            disabled={exportLoading}
                                        >
                                            {exportLoading ? (
                                                <>{t('exporting')}...</>
                                            ) : (
                                                <>
                                                    <Download
                                                        width={14}
                                                        height={14}
                                                        className="me-1"
                                                    />
                                                    {t('export')}
                                                </>
                                            )}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item
                                                onClick={() =>
                                                    handleExport('excel')
                                                }
                                            >
                                                <FileText
                                                    width={14}
                                                    height={14}
                                                    className="me-1"
                                                />
                                                {t('exportExcel')}
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                ) : null}
                            </>
                        )}

                        {tab === 'draft' && (
                            <>
                                {user?.userType == 'ADMIN' ? (
                                    <Button
                                        variant="outline-primary"
                                        onClick={() => setShowImportModal(true)}
                                    >
                                        <Upload
                                            width={14}
                                            height={14}
                                            className="me-1"
                                        />
                                        {t('Importer Excel')}
                                    </Button>
                                ) : null}
                            </>
                        )}

                        <Button
                            variant="primary"
                            onClick={() => {
                                setEditData({});
                                if (tab === 'draft') {
                                    setShowDraftModal(true);
                                } else {
                                    setShow(true);
                                }
                            }}
                        >
                            <Plus width={14} height={14} className="me-1" />
                            {tab === 'draft'
                                ? t('Ajouter un brouillon')
                                : t('addPatient')}
                        </Button>
                    </Stack>
                </Stack>

                {error && (
                    <Alert variant="danger" className="mb-3">
                        {error}
                        <Button variant="link" onClick={() => setError(null)}>
                            {t('dismiss')}
                        </Button>
                    </Alert>
                )}

                <Card>
                    <Card.Header>
                        <Stack
                            direction="horizontal"
                            gap={3}
                            className="listing_filters"
                        >
                            <Stack direction="horizontal" gap={3}>
                                <Form.Control
                                    type="text"
                                    onChange={handleChange}
                                    value={patientListConfig.search}
                                    name="search"
                                    placeholder={t('search')}
                                />
                                {tab === 'patient' && (
                                    <>
                                        <Form.Control
                                            type="date"
                                            onChange={handleChange}
                                            name="startDate"
                                            value={patientListConfig.startDate}
                                        />
                                        <Form.Control
                                            type="date"
                                            onChange={handleChange}
                                            name="endDate"
                                            value={patientListConfig.endDate}
                                        />
                                    </>
                                )}
                                <Button
                                    variant="secondary"
                                    onClick={() => handleFilterChange(1)}
                                >
                                    {t('search')}
                                </Button>
                            </Stack>
                            <div className="ms-auto">
                                <Button
                                    variant="link"
                                    className=""
                                    onClick={() => {
                                        removeSecureItem("patientListConfigCopy");
                                        setPatientListConfig(config);
                                        setLoading(true);
                                    }}
                                >
                                    {t('resetFilters')}
                                </Button>
                            </div>
                        </Stack>
                    </Card.Header>
                    <Card.Body className="table_outer">
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th></th>
                                    {tab === 'patient' && (
                                        <th>{t('patientNo')}</th>
                                    )}
                                    <th>{t('name')}</th>
                                    <th>{t('email')}</th>
                                    <th>{t('phone')}</th>
                                    {tab === 'draft' && (
                                        <th>{t('createdDate')}</th>
                                    )}
                                    <th className="text-center">
                                        {t('actions')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {!isEmpty ? (
                                    (tab === 'patient'
                                        ? patientData.listData.userProfileData
                                        : draftData
                                    ).map((patient, index) => (
                                        <tr key={index}>
                                            <td>
                                                <img
                                                    src={
                                                        patient.profileImagePath ||
                                                        '/avatar-s-11.jpg'
                                                    }
                                                    alt="profile"
                                                    style={{
                                                        height: '1.6rem',
                                                        width: '1.6rem',
                                                        borderRadius: '100%',
                                                        outline:
                                                            '1px solid #e9e9e9',
                                                        outlineOffset: '0.2rem',
                                                    }}
                                                />
                                            </td>
                                            {tab === 'patient' && (
                                                <td>
                                                    {patient.patientUniqueCode}
                                                </td>
                                            )}
                                            <td>
                                                {tab === 'draft'
                                                    ? `${patient.firstName || ''} ${patient.lastName || ''}`
                                                    : `${patient.name || ''} ${patient.lastName || ''}`}
                                            </td>
                                            <td>{patient.email}</td>
                                            <td>
                                                {tab === 'draft'
                                                    ? patient.phoneNumber
                                                    : patient.mobile}
                                            </td>
                                            {tab === 'draft' && (
                                                <td>
                                                    {patient.createddate
                                                        ? new Date(
                                                              patient.createddate
                                                          ).toLocaleDateString()
                                                        : ''}
                                                </td>
                                            )}
                                            <td>
                                                <Stack
                                                    direction="horizontal"
                                                    gap={1}
                                                    className="justify-content-center"
                                                >
                                                    <ButtonGroup>
                                                        {tab === 'patient' && (
                                                            <Button
                                                                variant="light"
                                                                size="sm"
                                                                onClick={() => {
                                                                    sessionStorage.setItem(
                                                                        'pageCount',
                                                                        JSON.stringify(
                                                                            {
                                                                                eyetest: 1,
                                                                                patient:
                                                                                    pageCount,
                                                                            }
                                                                        )
                                                                    );
                                                                    navigate(
                                                                        '/patient/view',
                                                                        {
                                                                            state: {
                                                                                userData:
                                                                                    patient.email,
                                                                                editable: false,
                                                                                isDraft:
                                                                                    tab ===
                                                                                    'draft',
                                                                            },
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                <Eye
                                                                    width={16}
                                                                />
                                                            </Button>
                                                        )}
                                                        <Button
                                                            variant="light"
                                                            size="sm"
                                                            onClick={() => {
                                                                sessionStorage.setItem(
                                                                    'pageCount',
                                                                    JSON.stringify(
                                                                        {
                                                                            eyetest: 1,
                                                                            patient:
                                                                                pageCount,
                                                                        }
                                                                    )
                                                                );
                                                                if (
                                                                    tab ===
                                                                    'draft'
                                                                ) {
                                                                    setShowDraftModal(
                                                                        true
                                                                    );
                                                                } else {
                                                                    setShow(
                                                                        true
                                                                    );
                                                                }
                                                                setEditData(
                                                                    patient
                                                                );
                                                            }}
                                                        >
                                                            <Pencil
                                                                width={16}
                                                            />
                                                        </Button>
                                                        {tab === 'draft' ? (
                                                            <>
                                                                <Button
                                                                    variant="light"
                                                                    size="sm"
                                                                    onClick={() =>
                                                                        handleApprovePatient(
                                                                            patient
                                                                        )
                                                                    }
                                                                    title={t(
                                                                        'approvePatient'
                                                                    )}
                                                                >
                                                                    <CheckCircle
                                                                        width={
                                                                            16
                                                                        }
                                                                    />
                                                                </Button>
                                                                <Button
                                                                    variant="light"
                                                                    size="sm"
                                                                    onClick={() =>
                                                                        handleDeleteDraft(
                                                                            patient.userId
                                                                        )
                                                                    }
                                                                    title={t(
                                                                        'deleteDraft'
                                                                    )}
                                                                >
                                                                    <Trash2
                                                                        width={
                                                                            16
                                                                        }
                                                                    />
                                                                </Button>
                                                            </>
                                                        ) : (
                                                            [
                                                                'ADMIN',
                                                                'BACKOFFICE',
                                                            ].includes(
                                                                user?.userType
                                                            ) && (
                                                                <DeleteUser
                                                                    email={
                                                                        patient.email
                                                                    }
                                                                    setLoading={
                                                                        setLoading
                                                                    }
                                                                />
                                                            )
                                                        )}
                                                    </ButtonGroup>
                                                </Stack>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={tab === 'draft' ? 7 : 6}>
                                            <Stack
                                                gap={2}
                                                className="mt-5 mb-5 mx-auto text-center"
                                            >
                                                <Image
                                                    src={NoDraft}
                                                    width={88}
                                                    className="mx-auto"
                                                />
                                                <h4>{t('noDataAvailable')}</h4>
                                                <p>
                                                    {tab === 'draft'
                                                        ? t(
                                                              "youHaven'tCreatedAnyDrafts"
                                                          )
                                                        : t(
                                                              "youHaven'tCreatedAnyPatients"
                                                          )}
                                                </p>
                                            </Stack>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                    {!isEmpty && (
                        <Card.Footer>
                            <Stack direction="horizontal" gap={3}>
                                <div className="ms-auto">
                                    <Stack direction="horizontal" gap={3}>
                                        <span>
                                            Page {pageCount} of{' '}
                                            {Math.ceil(
                                                (tab === 'patient'
                                                    ? patientData?.listData
                                                          ?.totalItems
                                                    : draftData?.length) /
                                                    patientListConfig.pageSize
                                            )}
                                        </span>

                                        <span>
                                            Affichage de{' '}
                                            {(pageCount - 1) *
                                                patientListConfig.pageSize +
                                                1}
                                            –
                                            {Math.min(
                                                pageCount *
                                                    patientListConfig.pageSize,
                                                tab === 'patient'
                                                    ? patientData?.listData
                                                          ?.totalItems
                                                    : draftData?.length
                                            )}{' '}
                                            of{' '}
                                            {tab === 'patient'
                                                ? patientData?.listData
                                                      ?.totalItems
                                                : draftData?.length}
                                        </span>

                                        <Button
                                            variant="secondary"
                                            disabled={pageCount <= 1}
                                            onClick={() =>
                                                handleFilterChange(
                                                    pageCount - 1
                                                )
                                            }
                                        >
                                            {t('prev')}
                                        </Button>

                                        <Button
                                            variant="secondary"
                                            disabled={
                                                pageCount >=
                                                Math.ceil(
                                                    (tab === 'patient'
                                                        ? patientData?.listData
                                                              ?.totalItems
                                                        : draftData?.length) /
                                                        patientListConfig.pageSize
                                                )
                                            }
                                            onClick={() =>
                                                handleFilterChange(
                                                    pageCount + 1
                                                )
                                            }
                                        >
                                            {t('next')}
                                        </Button>
                                    </Stack>
                                </div>
                            </Stack>
                        </Card.Footer>
                    )}
                </Card>

                <Modal
                    show={showImportModal}
                    onHide={() => setShowImportModal(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {tab === 'draft'
                                ? t('importDraftExcel')
                                : t('importExcel')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group controlId="formFile" className="mb-3">
                            <Form.Label>
                                {tab === 'draft'
                                    ? t('selectDraftExcelFile')
                                    : t('selectExcelFile')}
                            </Form.Label>
                            <Form.Control
                                type="file"
                                accept=".xlsx,.xls"
                                onChange={handleFileUpload}
                            />
                            <Form.Text className="text-muted">
                                {tab === 'draft'
                                    ? t('importDraftExcelInstructions')
                                    : t('importExcelInstructions')}
                            </Form.Text>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => setShowImportModal(false)}
                        >
                            {t('cancel')}
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleImportSubmit}
                            disabled={!selectedFile || importLoading}
                        >
                            {importLoading ? (
                                <>
                                    <Loader2
                                        className="me-2"
                                        size={16}
                                        style={{
                                            animation:
                                                'spin 1s linear infinite',
                                        }}
                                    />
                                    {t('importing')}...
                                </>
                            ) : (
                                t('import')
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <AddPatient
                    setLoading={setLoading}
                    show={show}
                    setShow={setShow}
                    editData={editData}
                />
                <AddDraftPatient
                    setLoading={setLoading}
                    show={showDraftModal}
                    setShow={setShowDraftModal}
                    editData={editData}
                    onApprove={handleApprovePatient}
                />
            </Container>
        </>
    );
};

export default PatientList;
